// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import { Auth0 } from './helper/auth'
import { ApiClient } from './helper/apiClient'

Vue.use(BootstrapVue)

let env = process.env

Vue.use(Auth0, {
  domain: env.auth0Domain,
  clientId: env.auth0ClientId,
  audience: env.auth0Audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  }
})

Vue.use(ApiClient, env.apiBaseUrl)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js